import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    this.element.addEventListener("turbo:submit-end", this.showRecentlyAdded.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.showRecentlyAdded)
  }

  showRecentlyAdded() {
    if (!$('#link-add').length) {
      $('#portfolio-tabs').prepend(`<li id="link-add" class="nav-item"> <a class="nav-link" data-toggle="tab" href="#tab-add">Recently Added</a></li>`);
      $('#portfolio-tabs a[href="#tab-add"]').tab('show');
      $("#link-add > ajax-btn-group").find(".ajax-indicator").css('display', 'inline-block');
    } else {
      $('a[href="#tab-add"]').tab('show');
      showTabPortfolio('#tab-add', $('#portfolio-tabs a[href="#tab-add"]')[0]);

      $("#link-add > ajax-btn-group").find(".ajax-indicator").css('display', 'inline-block');
    }
  }
}
